import { InfoPanelForOfficialDocumentation } from "../../../components/info-panel";
import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { OrderedList } from "./components/styled";
import { URLVerification, UtmParamsClipboard } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.TABOOLA;

const TABOOLA_OFFICIAL_DOC_URL = "#";

export const TaboolaDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const TaboolaSetup = () => (
  <>
    <SetupSection title="Add UTM parameters to all existing campaigns in Taboola">
      <OrderedList variant="upper-alpha">
        <>Navigate to the bottom of each ‘New Campaign / Edit Campaign’ page</>
        <>
          Copy and paste the parameters below into the ‘Tracking Code’ section.
        </>
      </OrderedList>
      <UtmParamsClipboard platform={PLATFORM} />
      <InfoPanelForOfficialDocumentation
        platform={PLATFORM}
        docUrl={TABOOLA_OFFICIAL_DOC_URL}
      />
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
